/** "Safety & Guardrails / {title}" header for the add-rule and review views. */
export const CrumbHeader = ({ title, onBack }: { title: string; onBack: () => void }) => (
  <nav aria-label="Breadcrumb" className="mb-5">
    <ol className="flex items-center gap-1.5 text-sm">
      <li>
        <button
          type="button"
          onClick={onBack}
          className="text-ink-muted hover:text-ink focus-visible:outline-primary rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          Safety &amp; Guardrails
        </button>
      </li>
      <li aria-hidden className="text-ink-subtle">
        /
      </li>
      <li className="text-ink font-semibold" aria-current="page">
        {title}
      </li>
    </ol>
  </nav>
);
